// 松・竹・梅プラン設定システム
export const PLAN_TYPES = {
  UME: 'ume',     // 梅プラン - 基本AI受付
  TAKE: 'take',   // 竹プラン - 視覚ナビ対応
  MATSU: 'matsu'  // 松プラン - 顔認証・AI対話
}

// 現在のプラン設定（環境変数または設定から取得）
export const getCurrentPlan = () => {
  // 環境変数からプランを取得（デフォルトは梅プラン）
  return import.meta.env?.VITE_PLAN_TYPE || 
         sessionStorage.getItem('alsok_plan_type') || 
         PLAN_TYPES.UME
}

// プラン設定を変更
export const setPlan = (planType) => {
  if (Object.values(PLAN_TYPES).includes(planType)) {
    sessionStorage.setItem('alsok_plan_type', planType)
    // カスタムイベントを発行してプラン変更を通知
    window.dispatchEvent(new CustomEvent('planChanged', { 
      detail: { planType, features: getCurrentPlanFeatures() } 
    }))
    console.log(`✅ プラン変更: ${planType}`)
    return true
  }
  return false
}

// プラン別機能定義
export const PLAN_FEATURES = {
  [PLAN_TYPES.UME]: {
    name: '梅プラン',
    description: '基本AI受付',
    features: {
      voiceReception: true,      // 音声受付
      emailNotification: true,   // メール通知
      calendarSync: true,        // カレンダー連携
      basicAvatar: true,         // 基本アバター
      videoIntro: true,          // イントロ動画
      mapDisplay: false,         // 地図表示
      avatarMotion: false,       // アバター動作
      visitorHistory: false,     // 来客履歴
      visualNavigation: false,   // 視覚ナビ
      faceAuth: false,           // 顔認証
      aiConversation: false,     // AI対話
      avatarCustomization: false // アバター切替
    },
    videoFile: 'ume_intro.mp4',
    videoDuration: 5,
    avatarGrade: 'ベーシック',
    avatarDescription: '基本的なアバター表示',
    color: '#90EE90' // ライトグリーン
  },
  
  [PLAN_TYPES.TAKE]: {
    name: '竹プラン', 
    description: '視覚ナビ対応',
    features: {
      voiceReception: true,      // 音声受付
      emailNotification: true,
      calendarSync: true,
      basicAvatar: true,
      videoIntro: true,          // イントロ動画
      mapDisplay: true,          // 地図表示
      avatarMotion: true,        // アバター動作
      visitorHistory: true,      // 来客履歴
      visualNavigation: true,    // 視覚ナビ
      faceAuth: false,
      aiConversation: false,
      avatarCustomization: false
    },
    videoFile: 'take_intro.mp4',
    videoDuration: 7,
    avatarGrade: 'スタンダード',
    avatarDescription: 'ジェスチャー付きアバター',
    color: '#FFD700' // ゴールド
  },
  
  [PLAN_TYPES.MATSU]: {
    name: '松プラン',
    description: '顔認証・AI対話',
    features: {
      voiceReception: true,      // 音声受付
      emailNotification: true,
      calendarSync: true,
      basicAvatar: true,
      videoIntro: true,          // イントロ動画
      mapDisplay: true,
      avatarMotion: true,
      visitorHistory: true,
      visualNavigation: true,
      faceAuth: true,            // 顔認証
      aiConversation: true,      // AI対話
      avatarCustomization: true  // アバター切替
    },
    videoFile: 'matsu_intro.mp4',
    videoDuration: 10,
    avatarGrade: 'プレミアム',
    avatarDescription: 'フルカスタマイズ対応アバター',
    color: '#FF6B6B' // レッド
  }
}

// 現在のプランの機能を取得
export const getCurrentPlanFeatures = () => {
  const currentPlan = getCurrentPlan()
  return PLAN_FEATURES[currentPlan] || PLAN_FEATURES[PLAN_TYPES.UME]
}

// 特定の機能が有効かチェック
export const isFeatureEnabled = (featureName) => {
  const planFeatures = getCurrentPlanFeatures()
  return planFeatures.features[featureName] || false
}

// プラン比較データ
export const PLAN_COMPARISON = [
  { feature: '音声受付', ume: true, take: true, matsu: true },
  { feature: 'メール通知', ume: true, take: true, matsu: true },
  { feature: 'カレンダー連携', ume: true, take: true, matsu: true },
  { feature: '地図表示', ume: false, take: true, matsu: true },
  { feature: 'アバター動作', ume: false, take: true, matsu: true },
  { feature: '来客履歴', ume: false, take: true, matsu: true },
  { feature: '視覚ナビ', ume: false, take: true, matsu: true },
  { feature: '顔認証', ume: false, take: false, matsu: true },
  { feature: '自然音声対話', ume: false, take: false, matsu: true },
  { feature: 'アバター切替', ume: false, take: false, matsu: true },
  { feature: 'アバターグレード', ume: 'ベーシック', take: 'スタンダード', matsu: 'プレミアム' }
]